import { Component, OnInit, inject } from '@angular/core';
import { SharedModule } from '@shared/module/shared.module';
import { LocalRepository } from '@shared/helper/local-repository';
import { BaseComponent } from '@shared/components/base/base.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImageCroppedEvent, ImageCropperModule, ImageTransform } from 'ngx-image-cropper';
import { SnackBarTypes } from '@shared/components/cutome-snack-bar/custome-snack-bar.component';
import { ICropperConfig, ICropperOutput } from '@shared/model/general/cropper-config.model';
import { ECropperImageType } from './models/cropper.enum';


enum EAspectRatio {
  One_One = 1,
  Two_One,
  Four_Five,
  Five_Six
}

@Component({
  selector: 'cropper',
  templateUrl: './custome-cropper.component.html',
  styleUrls: ['./custome-cropper.component.scss'],
  imports: [
    SharedModule,
    ImageCropperModule
  ]
})
export class CustomeCropperComponent extends BaseComponent implements OnInit {
  private _localRepository = inject(LocalRepository);
  config = inject<ICropperConfig>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<CustomeCropperComponent>>(MatDialogRef);

  imageChangedEvent: any = '';
  croppedImage: any = '';
  canvasRotation = 0;
  rotation = 0;
  scale = 1;
  containWithinAspectRatio = false;
  transform: ImageTransform = {};
  cropping!: boolean;
  isCircle!: boolean;
  isAspectRatioFixed = true;
  aspectRatio: number = 2 / 1;

  // ? mine
  extension = '';
  base64 = '';

  aspectRatioEnum = EAspectRatio;
  cropperImageType = ECropperImageType
  isMobile = false;

  ngOnInit(): void {
    if (this._localRepository.IsInBrowser) {
      this.isMobile = window.innerWidth <= 640;
    }
    // ? Set Config
    switch (this.config.aspect_ratio) {
      case ECropperImageType.circle_350:
        this.isCircle = true;
        this.aspectRatio = 1;
        break;
      case ECropperImageType.rectangle_350:
        this.aspectRatio = 2 / 1;
        break;
      case ECropperImageType.wide_rectangle_445:
        this.aspectRatio = this.isMobile ? 2.45 / 1 : 4.45 / 1;
        break;
      case ECropperImageType.rectangle_free:
        this.isAspectRatioFixed = false;
        this.aspectRatio = 1 / 2;
        break;
    }


    this.changeImage();
  }

  changeImage() {
    if (this._localRepository.IsInBrowser) {
      const input = this._localRepository.getDocument.getElementById('fileInput') as HTMLInputElement;
      input.click();
    }
  }

  fileChangeEvent(event?: any) {
    const file = event.target.files[0];
    if (!file) return;

    // check file size (must be less than 500KB)
    const fileSizeInKb = file.size / 1024;
    if (fileSizeInKb > 500) {
      this.snackbarService.openSnackbar(
        SnackBarTypes.error,
        'حجم تصویر انتخابی باید کوچکتر از 500 کیلوبایت باشد.'
      );
      this.dialogRef.close();
      return;
    }

    // check image dimensions (max: 2000x2000 pixels)
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const img = new Image();
      img.onload = () => {
        if (img.width > 2000 || img.height > 2000) {
          this.snackbarService.openSnackbar(
            SnackBarTypes.error,
            'ابعاد تصویر نباید بیشتر از 2000x2000 پیکسل باشد.'
          );
          this.dialogRef.close();
        } else {
          // Save the valid image event
          this.imageChangedEvent = event;
        }
      };
      img.src = e.target.result;
    };

    reader.readAsDataURL(file);
  }



  imageCropped(event?: ImageCroppedEvent) {
    this.cropping = false;

    // ? mine
    this.croppedImage = event?.objectUrl ? event?.objectUrl : this.croppedImage;
    this.fileToBase64(event?.objectUrl!)
      .then(croppedImage => {
        this.dataUrlToFile(croppedImage as string);
      })
      .catch(error => {
        console.error('Error processing file:', error);
      });
  }

  fileToBase64(objectUrl: string): Promise<string | ArrayBuffer> {

    // ? mine
    return new Promise((resolve, reject) => {
      fetch(objectUrl)
        .then(response => response.blob())
        .then(blob => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const result = reader.result as string;
            resolve(result);
          };
          reader.onerror = () => {
            reject(new Error('Error reading file'));
          };
          reader.readAsDataURL(blob);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  // ? refactor needed
  dataUrlToFile(croppedImage: string) {
    const separator = croppedImage.split(';');
    const fileType = separator[0].split('/');
    this.extension = fileType[1];
    const fileBase64 = separator[1].split(',');
    this.base64 = fileBase64[1];
  }

  loadImageFailed() {
    this.snackbarService.openSnackbar(SnackBarTypes.error, 'متاسفانه این تصویر قابل بارگذاری نمی‌باشد.' );
    this.dialogRef.close();
  }

  rotateLeft() {
    this.canvasRotation = this.canvasRotation - 10;
    this.flipAfterRotate();
  }

  rotateRight() {
    this.canvasRotation = this.canvasRotation + 10;
    this.flipAfterRotate();
  }

  flipAfterRotate() {
    this.transform = {
      rotate: this.canvasRotation
    };
  }

  zoomOut() {
    this.scale -= 0.05;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomIn() {
    this.scale += 0.05;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };

  }

  changeAspectRatio(ratio: EAspectRatio) {
    switch (ratio) {
      case EAspectRatio.One_One:
        this.aspectRatio = 1 / 1;
        break;
      case EAspectRatio.Two_One:
        this.aspectRatio = 2 / 1;
        break;
      case EAspectRatio.Four_Five:
        this.aspectRatio = 4 / 5;
        break;
    }
  }


  savePicture() {
    this.cropping = true;
    const output: ICropperOutput = {
      croppedImageData: this.croppedImage,
      base64: this.base64,
      type: this.config.fileType,
      ratio: this.aspectRatio
    }
    this.dialogRef.close(output);
  }
}